module.exports = __webpack_public_path__ + "img/cooperation03.0666b9e5.png";